export const THEME_TONE_STORAGE_KEY = 'ayrade-platform-tone';
export const THEME_TONE_CHANGED_EVENT = 'ayrade-platform-tone-changed';

export const THEME_TONES = [
  {
    id: 'azure-blue',
    label: 'Azure blue',
    primary: '#3399FF',
    primaryLight: '#0039A9',
    secondary: '#66B2FF',
    secondaryLight: '#027DFF',
    lightAccent: '#E8F3FF',
    darkAccent: '#071B33',
  },
] as const;

export type ThemeTone = (typeof THEME_TONES)[number]['id'];

export const DEFAULT_THEME_TONE: ThemeTone = 'azure-blue';

export const isThemeTone = (value: string | null | undefined): value is ThemeTone => (
  THEME_TONES.some(tone => tone.id === value)
);

export const getThemeTone = (tone: ThemeTone) => (
  THEME_TONES.find(candidate => candidate.id === tone) ?? THEME_TONES[0]
);

export const getStoredThemeTone = (): ThemeTone => {
  if (typeof window === 'undefined') {
    return DEFAULT_THEME_TONE;
  }
  const storedTone = window.localStorage.getItem(THEME_TONE_STORAGE_KEY);
  return isThemeTone(storedTone) ? storedTone : DEFAULT_THEME_TONE;
};

export const persistThemeTone = (tone: ThemeTone) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(THEME_TONE_STORAGE_KEY, tone);
  window.dispatchEvent(new CustomEvent(THEME_TONE_CHANGED_EVENT, { detail: tone }));
};
